import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useAccordionDetailsStyles = makeStyles({ name: 'accordionDetails' })((theme) => ({
	root: {
		padding: `${theme.spacing.small} 0 0`,
	},
}));

export const useAccordionStyles = makeStyles({ name: 'accordion' })(() => ({
	root: {
		boxShadow: 'none',
		backgroundColor: 'transparent',
	},
}));

export const useAccordionSummaryStyles = makeStyles({ name: 'accordionSummary' })((theme) => ({
	root: {
		minHeight: 0,
		padding: 0,
	},
	content: {
		margin: 0,
	},
	expanded: {
		'&&': {
			margin: 0,
			display: 'flex',
			alignItems: 'center',
			minHeight: theme.spacing.medium,
		},
	},
}));
